__turbopack_context__.v({
  "emptyState": "component-module__yutPfq__emptyState",
  "grid": "component-module__yutPfq__grid",
  "hero": "component-module__yutPfq__hero",
  "heroCounts": "component-module__yutPfq__heroCounts",
  "heroExpanded": "component-module__yutPfq__heroExpanded",
  "heroInbox": "component-module__yutPfq__heroInbox",
  "heroLabel": "component-module__yutPfq__heroLabel",
  "heroText": "component-module__yutPfq__heroText",
  "heroTextOnly": "component-module__yutPfq__heroTextOnly",
  "heroTotal": "component-module__yutPfq__heroTotal",
  "ring": "component-module__yutPfq__ring",
  "root": "component-module__yutPfq__root",
  "statIcon": "component-module__yutPfq__statIcon",
  "statLabel": "component-module__yutPfq__statLabel",
  "statTile": "component-module__yutPfq__statTile",
  "statValue": "component-module__yutPfq__statValue",
});
